import React from 'react';
import { Box } from '@mui/material';
import CatalogPage from '../components/CatalogPage';
import Image from '../components/Image';
import ShareModal from '../components/ShareModal';
import { useCatalogState } from '../hooks/useCatalogState';

export default function TopPage() {
  const state = useCatalogState('character');
  const [shareUrl, setShareUrl] = React.useState('');
  const [shareModalOpen, setShareModalOpen] = React.useState(false);

  if (state.loading) {
    return null;
  }

  return (
    <>
      <CatalogPage
        title="キャラクター所持チェッカー"
        state={state}
        onTogglePossession={state.togglePossession}
        onSetRarity={state.setRarity}
        onShare={async () => {
          const url = state.createShareUrl();
          if (!url) return;
          setShareUrl(url);
          setShareModalOpen(true);
        }}
        rarityOptions={[]}
        renderRarityControl={(item, onSetRarity, { interactive = true } = {}) => {
          const selected = Number(item.rarity || 0);
          const disabled = !item.possessed || !interactive;
          const stars = [1, 2, 3, 4, 5];
          const hexes = [6, 7, 8];

          const handlePick = (value) => {
            if (disabled) return;
            onSetRarity(item.id, value);
          };

          return (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                py: 0.8,
                opacity: disabled ? 0.3 : 1,
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.1 }}>
                {stars.map((value) => {
                  const active = selected >= value;
                  return (
                    <Box
                      key={`star-${value}`}
                      onClick={() => handlePick(value)}
                      sx={{
                        cursor: disabled ? 'default' : 'pointer',
                        fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.85rem' },
                        lineHeight: 1,
                        color: active ? '#facc15' : 'rgba(255,255,255,0.15)',
                        textShadow: active ? '0 0 10px rgba(250, 204, 21, 0.8)' : 'none',
                        transition: 'all 0.2s',
                        '&:hover': { transform: disabled ? 'none' : 'scale(1.2)' },
                        userSelect: 'none'
                      }}
                    >
                      ★
                    </Box>
                  )
                })}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.2, mt: 0.4 }}>
                {hexes.map((value) => {
                  const active = selected >= value;
                  return (
                    <Box
                      key={`hex-${value}`}
                      onClick={() => handlePick(value)}
                      sx={{
                        cursor: disabled ? 'default' : 'pointer',
                        fontSize: { xs: '0.55rem', sm: '0.65rem', md: '0.75rem' },
                        lineHeight: 1,
                        color: active ? '#ec4899' : 'rgba(255,255,255,0.15)',
                        textShadow: active ? '0 0 10px rgba(236, 72, 153, 0.8)' : 'none',
                        transition: 'all 0.2s',
                        '&:hover': { transform: disabled ? 'none' : 'scale(1.2)' },
                        userSelect: 'none'
                      }}
                    >
                      ⬢
                    </Box>
                  )
                })}
              </Box>
            </Box>
          );
        }}
        renderMainImage={(item) => (
          <Image
            src={`/img/chara/${item.id}.png`}
            alt={item.name}
            style={{
              width: '100%',
              aspectRatio: '1 / 1',
              objectFit: 'cover',
              filter: item.possessed ? 'none' : 'grayscale(100%)',
            }}
          />
        )}
      />
      <ShareModal
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        shareUrl={shareUrl}
      />
    </>
  );
}
